module.exports = __webpack_public_path__ + "img/login.87e49c0e.svg";